import React, { ReactNode, useEffect } from 'react';
import { useAppDispatch, closeModal } from '@breakroom-nx/redux';
import { Modal, ScrollView } from 'native-base';

export interface ModalWrapperProps {
  disabled?: boolean;
  children?: ReactNode;
}

export function ModalWrapper({
  children,
  disabled = false,
}: ModalWrapperProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // console.log(`Rendering Modal Wrapper`);
  });

  return (
    <Modal
      isOpen={true}
      onClose={() => (disabled ? null : dispatch(closeModal()))}
      bg={'rgba(0, 0, 0, 0.4)'}
    >
      <Modal.Content
        maxHeight={'90%'}
        width={'full'}
        bg={'transparent'}
        rounded={'25px'}
      >
        <ScrollView flex={1} showsVerticalScrollIndicator={true}>
          {children}
        </ScrollView>
      </Modal.Content>
    </Modal>
  );
}
